import React, { Component } from 'react'
import './App.scss'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { connect } from "react-redux"
import * as sdk from "lib/sdk"
import SupportModal from 'components/supportModal'
import { updateAccount } from 'lib/redux/actions'
import { selectAccount } from 'lib/redux/selectors'
import { pubsub } from 'lib/event'
import { getAccountResources } from 'lib/tron'
import Home from 'pages/home'
import V1Unstake from 'pages/v1unstake'
import {getAccounts} from "lib/sdk";

interface Props {
  account: any
  updateAccount: (any) => {}
}

class App extends Component<Props> {

  componentWillMount() {
    sdk.navigatorConfigure({ navigatorColor: '#191b31' })
  }

  componentDidMount() {
    getAccounts().then(accounts => {
      const account = accounts[0]
      this.props.updateAccount({ address: account })
      this.refreshAccountInfo()
    }).catch(e => {
      console.warn(e)
    })

    pubsub.on('refreshAccountInfo', this.refreshAccountInfo)
  }

  refreshAccountInfo = () => {
    const account = this.props.account
    getAccountResources(account.address).then(ret => {
      this.props.updateAccount({
        accountInfo: ret.account,
        resource: ret.resource
      })
    })
  }

  render() {
    return <BrowserRouter basename="/tron">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/v1unstake" component={V1Unstake} />
      </Switch>
      <SupportModal />
    </BrowserRouter>
  }
}

const mapStateToProps = state => {
  return {
    account: selectAccount(state)
  }
}

const mapDispatchToProps = {
  updateAccount: updateAccount
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
